import { useQuery } from "@tanstack/react-query";
import { anMetni } from "@koclukpanel/ui";
import { bakimDurumu } from "./api";

/**
 * BAKIM BANDI — F-SEC-06
 *
 * ================================================================
 * SUNUCU SÖYLÜYORDU, KİMSE DİNLEMİYORDU
 * ================================================================
 * Canlı ölçüldü (05.09.2026): bakım açıkken muaf olmayan her uç
 * `503 BAKIM_MODU` dönüyor. Panelde bunu okuyan tek yer
 * `TeknikKonsol.tsx`ti — yani bakımı **yöneten** kişinin ekranı.
 * Sıradan kullanıcı her ekranda genel hata görüyordu; sistemin ona
 * söyleyecek nazik bir cümlesi olduğu hâlde.
 *
 * ================================================================
 * METİN SUNUCUDAN — UYDURULMUYOR
 * ================================================================
 * Başlık ve mesaj `/bakim/durum`dan geliyor ve **aynen** gösteriliyor.
 * Kendi metnimizi yazsaydık yöneticinin yazdığı açıklama kullanıcıya
 * hiç ulaşmazdı — oysa "saat 03:00'te biter" bilgisini yalnızca o
 * biliyor. Sunucu iki alanı zaten zorunlu tutuyor (`min(3)`/`min(10)`).
 *
 * ================================================================
 * ÖĞRENCİ UYGULAMASINDAKİ İKİZİ `react-query` KULLANMIYOR
 * ================================================================
 * Orada kabuk, sağlayıcısı olmayan yerlerde de çiziliyor ve
 * `useQuery` bütün uygulamayı düşürdü (ölçüldü: 15 test). Burada
 * kalmasının sebebi ölçülmüş: panel kabuğu HER ZAMAN sağlayıcının
 * içinde (786 test bunu doğruluyor) ve `TeknikKonsol.tsx` aynı
 * `["bakim-durum"]` anahtarını kullanıyor — yani iki ekran tek
 * istekle besleniyor.
 *
 * Fark bir tutarsızlık değil, iki farklı kısıtın iki farklı cevabı.
 *
 * ================================================================
 * KİMLİK GEREKTİRMİYOR
 * ================================================================
 * Uç `@HerkeseAcik()`. Bu yüzden bant giriş ekranında da
 * gösterilebiliyor: kullanıcı şifresini yazıp içeri girdikten SONRA
 * öğrenmesin.
 */
export function BakimBandi(): React.ReactElement | null {
  const durum = useQuery({
    queryKey: ["bakim-durum"],
    queryFn: bakimDurumu,
    /*
      Bakım AÇILDIĞINDA kullanıcı bunu dakikalarca sonra öğrenmemeli;
      kapandığında da bandın ekranda kalması yanlış bilgi olur. Sunucu
      tarafında bu uç zaten ucuz (tek satır sorgu + kısa önbellek).
    */
    refetchInterval: 60_000,
    // Bakım bilgisi alınamıyorsa bant GÖSTERİLMİYOR: "bilmiyorum"
    // durumunda "bakımda" demek, çalışan bir sistemi bozuk göstermek
    // olurdu.
    retry: false,
  });

  if (!durum.data?.acik) return null;

  const bitis = durum.data.bitisTahmini;

  return (
    <div
      // `role="status"` — ekran okuyucu bandı DUYURSUN. Yalnızca renk
      // ve konumla anlatılan bir durum, görmeyen kullanıcı için yok.
      role="status"
      className="border-uyari-200 bg-uyari-50 text-uyari-800 flex flex-wrap items-baseline gap-x-2 gap-y-1 border-b px-4 py-2 text-sm"
    >
      <strong>{durum.data.baslik ?? "Bakım çalışması"}</strong>
      <span>{durum.data.mesaj}</span>
      {bitis !== null && <span className="text-uyari-600">Tahmini bitiş: {anMetni(bitis)}</span>}
    </div>
  );
}
